module.exports = __webpack_public_path__ + "app/assets/images/baby1-874435ec97a7eeedc50f8e62ba761a97.jpg";